/**
 * Created by xiaoconghu on 2018/11/19.
 */

export * from './xc-i18n.module';
export * from './xc-i18n.interface';
export * from './xc-i18n.service';
export * from './language/zh_CN';
export * from './language/en_US';
